module.exports = __webpack_public_path__ + "5ade285650551e91355b1a076ed3a490.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-660.webp
// module id = 296
// module chunks = 0